import type { FaireProductEntity } from "../../entity_types/product";

export const p_nn29vbn7bh: FaireProductEntity = {
  token: "p_nn29vbn7bh",
  type: "product",
  name: "Quilted Tote, Pink Tile Floral",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/a14f452d55c8c34b5b5011bcbbe4fe66a2c28961b59e3a26bbbf906d5e2f8aad.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2680624750b2da6f0352fc2a1d4208743487ef10e6cf3e5e5951aaf20be77b55.jpeg",
    "https://cdn.faire.com/fastly/664dafeed3047cbfc29dd857debb92ee7e59cccf3149ea46e7866fd9f30c7741.jpeg",
    "https://cdn.faire.com/fastly/07151b0221f709a463d0798dec75ba9da2df03d7ac11ab33ba915b7f5385acff.jpeg",
    "https://cdn.faire.com/fastly/51bb3120275bf47db50b0f0e83a0ee2171fe2e262ff80ef82640e2d637150cb6.jpeg"
  ],
  priceDollars: 14.5,
  description: "Because we love quilts and we love tote bags. Featuring an all-over pink floral design, this is the ideal companion for running errands, hitting up a farmers market, or exploring a new part of town.\n\nFeatures:\nQuilted tote bag with a soft, padded feel\nAll-over pink floral design for a sweet, stylish look\nSpacious interior for groceries, books, or daily essentials\nLightweight and comfortable for everyday use\nDesigned in Bando’s signature bright and cheerful style\n\nIdeal For:\nGift shops and lifestyle boutiques\nFashion and accessory retailers\nMarket shoppers, students, and everyday adventurers\nWholesale buyers seeking cute, functional quilted bags",
  tags: [],
  msrpDollars: 29.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:43.118Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
